<template>
	<el-card :body-style="{ padding: '0' }">
		<div slot="header" class="appointment header">
			<img src="../image/chart_notes.png" class="header-icon">
			<span class="head-title-col">Chart Notes</span>
		</div>
		<ChartTable :patient="patient"
			:event="patientEvents">
		</ChartTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

import ChartTable from './Table'

export default {
	name: 'chart-card',
	extends: OverviewCard,

	// mounted() {
	// 	this.loadPatientChart({
	// 		id: this.patient.id
	// 	})
	// },

	computed: {
		...mapGetters('content', [
			'getContent'
		])
	},

	components: {
		ChartTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>

<style scoped>
.el-card >>> .el-card__header {
	z-index: 1000;
	border-top: 1px solid #eeeeee;
	border-bottom: 1px solid #eeeeee;
}
.header-icon {
	height: 43px !important;
	margin-top: -1px !important;
}
</style>
